@if (totalCount == 0) {
  <div id="attachments-no-results" role="status" class="w-full flex items-center justify-center p-4">
    No Attachments found
  </div>
}

<div id="attachments-header" class="w-full flex justify-between p-4">
  <ul id="attachments-category-list" class="flex flex-wrap text-sm font-normal text-center" role="tablist">
    @for (category of categories; track category.attachment_type_id) {
      <li id="attachments-category-item-{{$index}}" class="me-2" role="presentation">
        <button
          id="attachments-category-btn-{{category.attachment_type_id}}"
          (click)="filterByCategory(category)"
          [class.hidden]="category.count === 0"
          [class.selected]="selectedCategoryId === category.attachment_type_id"
          class="text-zinc-500 text-sm font-normal font-['Inter'] inline-block p-4 rounded-t-lg transform translate-y-[1px] hover:text-gray-600"
          type="button" role="tab" aria-selected="false">
          {{ category.attachment_type }} ({{ category.count }})
        </button>
      </li>
    }
  </ul>

  @if (selectedCategoryId == "1") {
    <div id="attachments-search-container"
         class="flex items-center h-fit border border-gray-300 rounded-lg w-fit bg-gray-50">
      <svg class="ml-2 h-5 w-5 pr-1 text-gray-600" width="15" height="16" viewBox="0 0 15 16" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <g id="Left Icon">
          <path id="Vector"
                d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                stroke="#1D1929"/>
        </g>
      </svg>
      <input id="attachments-search-input" [(ngModel)]="search" (change)="filterPaperWorkSearchChanged()"
             type="text" placeholder="Attachment(s) Lookup" class="input-custom"/>
    </div>
  }
</div>

@for (groupId of getGroupKeys(filteredGroupedData); track groupId; let groupIndex = $index) {
  <div id="attachments-group-{{groupIndex}}" class="flex flex-col">
    <div id="attachments-group-container-{{groupIndex}}"
         class="px-8 py-4 bg-white rounded-lg shadow flex justify-center items-start gap-4 flex-wrap">
      @for (item of filteredGroupedData[groupId]; track item; let itemIndex = $index) {
        <attachment-card [attachment]="item" [idPostfix]="groupIndex + '-' + itemIndex"/>
      }
      @if (selectedCategory.count > 5) {
        <div id="attachments-group-showmore-{{groupIndex}}" class="w-full mt-4 flex justify-end">
          <a id="attachments-group-showmore-btn-{{groupIndex}}"
             (click)="handleShowMore(selectedCategory.attachment_type_id)"
             class="text-blue-500 hover:underline cursor-pointer">Show More</a>
        </div>
      }
    </div>
  </div>
}

<!-- Show message if there are no attachments -->
@if (totalItems == 0) {
  <div id="attachments-empty-message" class="px-8 py-4 flex justify-center items-center">
    <p class="text-gray-500 text-lg">No Attachments Found</p>
  </div>
}
